// extracted by mini-css-extract-plugin
module.exports = {"label":"Textarea_label__3Bf_8","textarea":"Textarea_textarea__1WlSp"};